export default [
    {
      path: '/payments',
      name: 'payments',
      component: () => import('@/views/sft/Payments.vue'),
    },
  ]